AGADash.Details = (function () {

    var getPanelElement = function (detail) {
        var div = document.createElement("div");
        $(div).addClass("row");

        var col = document.createElement("div");
        $(col).addClass("col-md-12").appendTo(div);

        var dash = document.createElement("div");
        $(dash).attr({
            "class": "aga-dash-panel",
            "data-filter": "detail",
            "data-filter-key": detail.DetailFilterValues,
            "data-id": detail.DetailPanelId
        }).appendTo(col);

        return div;
    };

    var getTableHead = function (detail) {
        var thead = document.createElement("thead");
        var tr = document.createElement("tr");
        $(tr).appendTo(thead);

        var formats = detail.Formats;
        for (var i = 0; i < formats.length; i++) {
            var th = document.createElement("th");

            if (formats[i].DataType === "N")
                $(th).addClass("text-right");
            else if (formats[i].DataType === "D")
                $(th).addClass("text-center");

            $(th).text(formats[i].Title).appendTo(tr);
        }
        return thead;
    };

    var getTableBody = function (detail) {
        var formats = detail.Formats;

        var tbody = document.createElement("tbody");
        for (var index = 0; index < detail.Values.length; index++) {
            var tr = document.createElement("tr");
            $(tr).appendTo(tbody);

            for (var i = 0; i < formats.length; i++) {
                var td = document.createElement("td");

                if (formats[i].DataType === "N")
                    $(td).addClass("text-right");
                else if (formats[i].DataType === "D")
                    $(td).addClass("text-center");

                var value = detail.Values[index][i];
                $(td).text(AGADash.Common.Formatter.formatByInfo(formats[i], value)).appendTo(tr);
            }
        }
        return tbody;
    };


    var getGridElement = function (detail) {
        var table = document.createElement("table");
        $(table).attr({
            "class": "table table-hover table-detail",
            "cellspacing": "0",
            "border": "0",
            "style": "border-collapse:collapse;"
        });

        $(table).append(getTableHead(detail));
        $(table).append(getTableBody(detail));

        // Habilitar exportação
        if (AGATableExport)
            AGATableExport.createLink(table);

        var div = document.createElement("div");
        $(div).append(table);

        // Paginar
        AGADash.Pagination.paginate(table, 10);

        return div;
    };

    var getDetailBody = function (detail) {
        var pnl = detail["DetailFilterValues"];
        if (pnl && pnl.length > 0)
            return getPanelElement(detail);
        else
            return getGridElement(detail);
    };
    
    var render = function (placeHolder, data) {
        $(placeHolder).empty().hide();

        var root;
        var content;
        if (data.length === 1 && (data[0].ShowTitle === "N")) {
            root = getDetailBody(data[0]);
        } else {
            root = document.createElement("ul");
            $(root).addClass("nav nav-tabs aga-tabs").attr("data-tabs", "tabs");

            content = document.createElement("div");
            $(content).addClass("tab-content");

            for (var i = 0; i < data.length; i++) {
                var current = data[i];
                var li = document.createElement("li");
                $(li).addClass("aga-li").appendTo(root);

                var a = document.createElement("a");
                $(a).attr({
                    "data-toggle": "tab",
                    "href": "#detail_" + i.toString(),
                    "aria-expanded": "true"
                }).text(current.Title).appendTo(li);

                var pane = document.createElement("div");
                $(pane).addClass("tab-pane").attr("id", "detail_" + i.toString()).appendTo(content);
                $(pane).append(getDetailBody(current));

                if (i === 0) {
                    $(li).addClass("active");
                    $(a).addClass("aga-a-active");
                    $(pane).addClass("active");
                }
            }
        }

        $(root).appendTo(placeHolder);
        if (content)
            $(content).appendTo(placeHolder);

        $(placeHolder).slideDown(300);
        $(placeHolder).find(".aga-dash-panel").each(function (index, obj) {
            AGADash.Panel.init(obj);
        });
    };

    return {
        render: render
    };
})();